import { useRef, useState } from 'react';

// Same country choices and Kenya default as the member app's phone input.
const COUNTRIES = [
    ['KE', 'Kenya', '+254', '🇰🇪'], ['UG', 'Uganda', '+256', '🇺🇬'],
    ['TZ', 'Tanzania', '+255', '🇹🇿'], ['RW', 'Rwanda', '+250', '🇷🇼'],
    ['ET', 'Ethiopia', '+251', '🇪🇹'], ['NG', 'Nigeria', '+234', '🇳🇬'],
    ['ZA', 'South Africa', '+27', '🇿🇦'], ['GH', 'Ghana', '+233', '🇬🇭'],
    ['US', 'United States', '+1', '🇺🇸'], ['GB', 'United Kingdom', '+44', '🇬🇧'],
    ['AE', 'UAE', '+971', '🇦🇪'], ['IN', 'India', '+91', '🇮🇳'],
];

export function CareerPhone({ country, phone, onCountry, onPhone }) {
    const dialog = useRef(null);
    const [search, setSearch] = useState('');
    const selected = COUNTRIES.find(c => c[0] === country) || COUNTRIES[0];
    return <div className="career-field">
        <label htmlFor="career-phone">Phone number *</label>
        <div className="career-phone">
            <button type="button" aria-label={`Country code: ${selected[1]} ${selected[2]}`} onClick={() => { setSearch(''); dialog.current.showModal(); }}>
                {selected[3]} {selected[2]} <span aria-hidden="true">⌄</span>
            </button>
            <input id="career-phone" type="tel" autoComplete="tel-national" required maxLength={24} pattern="[0-9 \(\)\-]{6,24}"
                placeholder="700 000 000" value={phone} onChange={e => onPhone(e.target.value)} />
        </div>
        <dialog ref={dialog} className="career-country-dialog" aria-labelledby="country-title">
            <div className="career-dialog-heading"><h3 id="country-title">Select country</h3><button type="button" onClick={() => dialog.current.close()} aria-label="Close country selector">×</button></div>
            <input aria-label="Search countries" placeholder="Search country or dial code" value={search} onChange={e => setSearch(e.target.value)} />
            <div className="career-country-list">
                {COUNTRIES.filter(c => c.join(' ').toLowerCase().includes(search.toLowerCase())).map(c =>
                    <button type="button" key={c[0]} aria-pressed={country === c[0]} onClick={() => { onCountry(c[0], c[2]); dialog.current.close(); }}>
                        <span>{c[3]} {c[1]}</span><span>{c[2]}</span>
                    </button>)}
                {!COUNTRIES.some(c => c.join(' ').toLowerCase().includes(search.toLowerCase())) && <p>No countries found.</p>}
            </div>
        </dialog>
    </div>;
}

export function CareerTags({ label, options, values, onChange }) {
    const [custom, setCustom] = useState('');
    const toggle = value => onChange(values.includes(value) ? values.filter(v => v !== value) : [...values, value].slice(0, 20));
    const add = () => {
        const value = custom.trim();
        if (value && !values.some(v => v.toLowerCase() === value.toLowerCase()) && values.length < 20) onChange([...values, value]);
        setCustom('');
    };
    return <div className="career-tags">
        <p className="career-label">{label} *</p>
        <div className="career-chips" role="group" aria-label={label}>
            {[...new Set([...options, ...values])].map(value => <button type="button" key={value} aria-pressed={values.includes(value)} onClick={() => toggle(value)}>
                {values.includes(value) && <span aria-hidden="true">✓ </span>}{value}
            </button>)}
        </div>
        <div className="career-custom-tag"><input aria-label={`Add another ${label.toLowerCase()}`} placeholder="Something else? Add your own" maxLength={120}
            value={custom} onChange={e => setCustom(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} />
            <button type="button" onClick={add} disabled={!custom.trim() || values.length >= 20}>Add +</button>
        </div>
    </div>;
}

export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export function CareerAvailability({ slots, onChange }) {
    const update = (index, key, value) => onChange(slots.map((s, i) => i === index ? { ...s, [key]: value } : s));
    return <>
        <p className="career-help">Use local Kenya time (EAT, UTC+3). Add one or more same-day time slots.</p>
        {slots.map((slot, index) => <div className="career-slot" key={index}>
            <label>Day *<select aria-label={`Day ${index + 1}`} value={slot.day} onChange={e => update(index, 'day', e.target.value)} required>{DAYS.map(d => <option key={d}>{d}</option>)}</select></label>
            <label>From *<input type="time" aria-label={`From ${index + 1}`} required value={slot.from_time} onChange={e => update(index, 'from_time', e.target.value)} /></label>
            <label>To *<input type="time" aria-label={`To ${index + 1}`} required value={slot.to_time} onChange={e => update(index, 'to_time', e.target.value)} /></label>
            <button type="button" className="career-remove" disabled={slots.length === 1} aria-label={`Remove availability ${index + 1}`} onClick={() => onChange(slots.filter((_, i) => i !== index))}>×</button>
        </div>)}
        <button className="career-text-button" type="button" disabled={slots.length >= 21} onClick={() => onChange([...slots, { day: DAYS[slots.length % 7], from_time: '', to_time: '' }])}>+ Add availability</button>
    </>;
}
